export const BASE = {
  name: 'trends',
  path: '/sites/:siteId/trends',
};
